import LeadTasksAPI from '../../../api/masifi/leadTasks';

// Módulo liviano que alimenta el badge "Agenda" del sidebar (tareas que
// requieren atención: vencidas + de hoy, del usuario actual).
export const state = {
  stats: { pending: 0, overdue: 0, due_today: 0 },
};

export const getters = {
  getAgendaStats: $state => $state.stats,
  getAgendaDueCount: $state =>
    ($state.stats.overdue || 0) + ($state.stats.due_today || 0),
};

export const actions = {
  fetchStats: async ({ commit }, params = {}) => {
    try {
      const { data } = await LeadTasksAPI.stats(params);
      commit('SET_AGENDA_STATS', data?.payload || {});
    } catch (error) {
      // El badge es informativo: si falla, no interrumpe la sesión.
    }
  },
};

export const mutations = {
  SET_AGENDA_STATS($state, stats) {
    $state.stats = {
      pending: stats.pending || 0,
      overdue: stats.overdue || 0,
      due_today: stats.due_today || 0,
    };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
